import React from 'react';
import Hero from '../components/home/Hero';
import Features from '../components/home/Features';
import CallToAction from '../components/home/CallToAction';

const Home = () => {
  return (
    <>
      <Hero />
      <Features />
      <CallToAction />
    </>
  );
};

export default Home;
